/**
 * Global /compare page. EvaluationPickerSheet → on pick → ComparisonView
 * (the F1+F2+F3+F4+F5+F6 component) inside the shared module-page chrome.
 * URL preserves the picked evaluation via `?eval=<id>` so reload + share-link
 * both work.
 *
 * Linear: MYD-222 (F7).
 *
 * Note on the "Sidebar Compare entry highlights" acceptance criterion: per
 * the user-locked sidebar IA (memory: feedback_sidebar_ia.md; canonical
 * implementation MYD-235), Compare is NOT a sidebar entry. The route
 * `/compare` remains valid and deep-linkable, but no sidebar item highlights
 * for it. The acceptance bullet is superseded by the IA lock — confirmed in
 * the Linear comment thread on this issue (Bucket-1 IA-lock comment,
 * 2026-04-30).
 */

import EvaluationModulePage from './_EvaluationModulePage'
import ComparisonView from '../components/comparison/ComparisonView'

const ComparePage = () => (
	<EvaluationModulePage
		moduleName="Compare"
		moduleDescription="Pick an evaluation, then select sites to compare side by side."
		workspacePhase="MYD-216 (F1)"
		workspaceHint="Multi-site picker with 7 comparison panels (Overview, Details, Scoring, Financials, Risks, Pros&Cons, Map)."
		renderWorkspace={(evalId) => <ComparisonView evalId={evalId} />}
	/>
)

export default ComparePage
